import fetcher from "./http";

import { buildQueryString } from "../../helpers";

export default {
    seatMap(appCode, tariffGroupId, params) {
        return new Promise((resolve, reject) => {
            fetcher(
                `/${appCode}/tariff-groups/${tariffGroupId}/seat-map?${buildQueryString(
                    params
                )}`,
                { method: "GET" }
            )
                .then(response => response.json())
                .then(data => resolve(data))
                .catch(error => reject(error));
        });
    }
};
